import { useState } from 'react';
import { Boton } from '../components/ui';
import { NOMBRE_APP } from '../marca';
import { estaInstalada, useInstalar } from './instalar';

export function AyudaInstalar() {
  const instalar = useInstalar(true);
  const [error, setError] = useState(false);

  return (
    <>
      <p>Instalá {NOMBRE_APP} para abrirla desde un ícono en la pantalla de inicio.</p>
      {estaInstalada() ? (
        <p role="status">Ya la estás usando como app instalada.</p>
      ) : instalar.tipo === 'android' ? (
        <Boton ancho chico onClick={() => {
          setError(false);
          void instalar.instalar().catch(() => setError(true));
        }}>
          Instalar app
        </Boton>
      ) : null}
      {error && <p role="status">No se pudo abrir la instalación. Probá desde el menú del navegador.</p>}
      <p><b>En Android:</b> tocá <b>Instalar app</b> y confirmá en el cartel del navegador. Si el botón no aparece, abrí este mismo enlace en Chrome y buscá <b>Instalar app</b> o <b>Agregar a la pantalla principal</b> en el menú ⋮.</p>
      <p><b>En iPhone:</b> la instalación se hace desde Safari:</p>
      <ol className="flex flex-col gap-1 [&_li]:list-decimal">
        <li>Abrí este mismo enlace en <b>Safari</b>. Si llegaste desde WhatsApp, abrilo en el navegador o copiá el enlace y pegalo en Safari.</li>
        <li>Tocá <b>Compartir</b> (el cuadrado con la flecha hacia arriba; puede estar dentro del menú de Safari).</li>
        <li>Elegí <b>Agregar a inicio</b> o <b>Agregar a la pantalla de inicio</b>. Si no aparece, buscala en <b>Editar acciones</b>.</li>
        <li>Si aparece <b>Abrir como app web</b>, dejalo activado y tocá <b>Agregar</b>.</li>
        <li>Abrí {NOMBRE_APP} desde el nuevo ícono.</li>
      </ol>
      <p>En iPhone puede pedirte el PIN otra vez al abrirla desde el ícono: la sesión de la app es independiente de Safari.</p>
    </>
  );
}
